import { HiOutlineDownload } from "react-icons/hi"
import PropTypes from "prop-types"
import {
  PDP_LABELS,
  TECHNICAL_INFORMATION_FILES_NAMES,
} from "@/components/detailsComponent/helper"
import { FaRegFilePdf } from "react-icons/fa"

const SpecItems = ({ downloadLink, linkType, locale }) => {
  const {
    "ProductResource.DWGFrontView.resourceFullWebURL_ss": dwgFrontView = [],
    "ProductResource.DWGPlanView.resourceFullWebURL_ss": dwgPlanView = [],
    "ProductResource.DWGSideView.resourceFullWebURL_ss": dwgSideView = [],
    "ProductResource.DXFFrontView.resourceFullWebURL_ss": dxfFrontView = [],
    "ProductResource.DXFPlanView.resourceFullWebURL_ss": dxfPlanView = [],
    "ProductResource.DXFSideView.resourceFullWebURL_ss": dxfSideView = [],
    "ProductResource.3D3DS.resourceFullWebURL_ss": product3D3DS = [],
    "ProductResource.3DDWGSymbol.resourceFullWebURL_ss":
      product3DDWGSymbol = [],
    "ProductResource.3DDXFSymbol.resourceFullWebURL_ss":
      product3DDXFSymbol = [],
    "ProductResource.3DOBJ.resourceFullWebURL_ss": product3DOBJ = [],
    "ProductResource.3DRevit.resourceFullWebURL_ss": product3DRevit = [],
    "ProductResource.3DSketchup.resourceFullWebURL_ss": product3DSketchup = [],
    "ProductResource.InstallationWithoutSPPDF.resourceFullWebURL_ss":
      productInstallationPDF = [],
    "ProductResource.SpecPDFFileName.resourceFullWebURL_ss":
      productSpecPDF = [],
    "ProductResource.PartsPDFFileName.resourceFullWebURL_ss":
      productPartsPDF = [],
  } = downloadLink || {}
  return linkType !== "technical" ? (
    <div className="block pl-[20px]">
      {dwgPlanView.length > 0 ||
      dwgFrontView.length > 0 ||
      dwgSideView.length > 0 ? (
        <div className="relative float-left min-h-1px pl-10px pr-10px pb-[15px]">
          <div className="pb-[10px]">
            <span className="font-bold text-[14px] leading-normal font-[helveticaBold,_Helvetica,_sans-serif]">
              {PDP_LABELS[locale].cadFiles2D}
            </span>
          </div>
          {dwgPlanView.length > 0 && (
            <>
              <span className="block my-4px">{PDP_LABELS[locale].plan}</span>
              <div className="flex py-[10px]">
                <ul className="flex p-0 my-4px list-none overflow-auto text-[14px] font-['Helvetica-Light',_Helvetica,_sans-serif] text-[#337ab7]">
                  <li className="pl-[0px] border-l-0 block float-left px-[5px]">
                    <a
                      target="_blank"
                      href={dwgPlanView[0]}
                      className=""
                      rel="noreferrer"
                    >
                      {dwgPlanView[0]?.split("/").slice(-1)[0]}
                    </a>
                  </li>
                  <li className="pl-[5px] block float-left px-[5px]  border-l border-solid border-gray-800 border-b-0">
                    <a target="_blank" href={dxfPlanView[0]} rel="noreferrer">
                      {dxfPlanView[0]?.split("/").slice(-1)[0]}
                    </a>
                  </li>
                </ul>
              </div>
            </>
          )}
          {dwgFrontView.length > 0 && (
            <>
              <span className="block my-4px">{PDP_LABELS[locale].front}</span>
              <div className="flex py-[10px]">
                <ul className="flex p-0 my-4px list-none overflow-auto text-[14px] font-['Helvetica-Light',_Helvetica,_sans-serif] text-[#337ab7]">
                  <li className="pl-[0px] border-l-0 block float-left px-[5px]">
                    <a
                      target="_blank"
                      href={dwgFrontView[0]}
                      className=""
                      rel="noreferrer"
                    >
                      {dwgFrontView[0]?.split("/").slice(-1)[0]}
                    </a>
                  </li>
                  <li className="pl-[5px] block float-left px-[5px] border-l border-solid border-gray-800 border-b-0">
                    <a target="_blank" href={dxfFrontView[0]} rel="noreferrer">
                      {dxfFrontView[0]?.split("/").slice(-1)[0]}
                    </a>
                  </li>
                </ul>
              </div>
            </>
          )}
          {dwgSideView.length > 0 && (
            <>
              <span className="block my-4px">{PDP_LABELS[locale].side}</span>
              <div className="flex py-[10px]">
                <ul className="flex p-0 my-4px list-none overflow-auto text-[14px] font-['Helvetica-Light',_Helvetica,_sans-serif] text-[#337ab7]">
                  <li className="pl-[0px] block float-left px-[5px]">
                    <a
                      target="_blank"
                      href={dwgSideView[0]}
                      className=""
                      rel="noreferrer"
                    >
                      {dwgSideView[0]?.split("/").slice(-1)[0]}
                    </a>
                  </li>
                  <li className="pl-[5px] block float-left px-[5px] border-l border-solid border-gray-800 border-b-0">
                    <a target="_blank" href={dxfSideView[0]} rel="noreferrer">
                      {dxfSideView[0]?.split("/").slice(-1)[0]}
                    </a>
                  </li>
                </ul>
              </div>
            </>
          )}
          {dwgFrontView.length > 0 && (
            <>
              <span className="block my-4px">{PDP_LABELS[locale].overall}</span>
              <div className="flex py-[10px]">
                <ul className="flex p-0 my-4px list-none overflow-auto text-[14px] font-['Helvetica-Light',_Helvetica,_sans-serif] text-[#337ab7]">
                  <li className="pl-[0px] border-l-0 block float-left px-[5px]">
                    <a
                      target="_blank"
                      href={dwgFrontView[0]}
                      className=""
                      rel="noreferrer"
                    >
                      {dwgFrontView[0]?.split("/").slice(-1)[0]}
                    </a>
                  </li>
                </ul>
              </div>
            </>
          )}
          <div className="koh-product-templates-3d">
            <span className="font-bold text-[14px] font-[helveticaBold,_Helvetica,_sans-serif]">
              {PDP_LABELS[locale].cadFiles3D}
            </span>
            <div className="flex py-[10px]">
              <ul className="flex flex-wrap p-0 my-4px list-none overflow-auto text-[14px] font-['Helvetica-Light',_Helvetica,_sans-serif] text-[#337ab7]">
                <li className="pl-[0px] border-l-0 block float-left px-[5px]">
                  <a
                    target="_blank"
                    href={product3DDXFSymbol[0]}
                    rel="noreferrer"
                  >
                    {product3DDXFSymbol[0]?.split("/").slice(-1)[0]}
                  </a>
                </li>
                <li className="pl-[5px] block float-left px-[5px] border-l border-solid border-gray-800 border-b-0">
                  <a target="_blank" href={product3D3DS[0]} rel="noreferrer">
                    {product3D3DS[0]?.split("/").slice(-1)[0]}
                  </a>
                </li>
                <li className="pl-[5px] block float-left px-[5px] border-l border-solid border-gray-800 border-b-0">
                  <a
                    target="_blank"
                    href={product3DSketchup[0]}
                    rel="noreferrer"
                  >
                    {product3DSketchup[0]?.split("/").slice(-1)[0]}
                  </a>
                </li>
                <li className="pl-[5px] block float-left px-[5px] border-l border-solid border-gray-800 border-b-0">
                  <a target="_blank" href={product3DRevit[0]} rel="noreferrer">
                    {product3DRevit[0]?.split("/").slice(-1)[0]}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  ) : (
    <div className="pl-[20px]">
      <ul className="flex flex-col p-0 my-4px list-none overflow-auto mb-[10px] text-[14px] font-['Helvetica-Light',_Helvetica,_sans-serif]  text-[#337ab7]">
        {productInstallationPDF.length ? (
          <li className="pl-[0px] flex float-left px-[5px]">
            <FaRegFilePdf className="pt-[4px]" color="red" size={15} />
            <a
              target="_blank"
              href={productInstallationPDF[0]}
              className=""
              rel="noreferrer"
            >
              {
                TECHNICAL_INFORMATION_FILES_NAMES[locale]
                  .InstallationWithoutSPPDF
              }
            </a>
          </li>
        ) : null}
        {productSpecPDF.length ? (
          <li className="pl-[0px] flex float-left px-[100px]">
            <FaRegFilePdf className="pt-[4px]" color="red" size={15} />
            <a
              target="_blank"
              href={productSpecPDF[0]}
              className=""
              rel="noreferrer"
            >
              {TECHNICAL_INFORMATION_FILES_NAMES[locale].SpecPDFFileName}
            </a>
          </li>
        ) : null}
        {productSpecPDF.length ? (
          <li className="pl-[0px] flex float-left px-[100px]">
            <FaRegFilePdf className="pt-[4px]" color="red" size={15} />
            <a
              target="_blank"
              href={productSpecPDF[0]}
              className=""
              rel="noreferrer"
            >
              {
                TECHNICAL_INFORMATION_FILES_NAMES[locale]
                  .matchingListPDFFileName
              }
            </a>
          </li>
        ) : null}
        {productPartsPDF.length ? (
          <li className="pl-[0px] flex float-left px-[100px]">
            <FaRegFilePdf className="pt-[4px]" color="red" size={15} />
            <a
              target="_blank"
              href={productPartsPDF[0]}
              className=""
              rel="noreferrer"
            >
              {TECHNICAL_INFORMATION_FILES_NAMES[locale].PartsPDFFileName}
            </a>
          </li>
        ) : null}

        {downloadLink?.HomeguideWithSPPDF && (
          <li className="pl-[0px]  flex float-left px-[100px]">
            <FaRegFilePdf className="pt-[4px]" color="red" size={15} />
            <a
              target="_blank"
              href={downloadLink?.HomeguideWithSPPDF}
              className=""
              rel="noreferrer"
            >
              {TECHNICAL_INFORMATION_FILES_NAMES[locale].HomeownersGuide}
            </a>
          </li>
        )}
        {downloadLink?.HomeguideWithoutSPPDF && (
          <li className="pl-[0px]  flex float-left px-[100px]">
            <FaRegFilePdf className="pt-[4px]" color="red" size={15} />
            <a
              target="_blank"
              href={downloadLink?.HomeguideWithoutSPPDF}
              className=""
              rel="noreferrer"
            >
              {TECHNICAL_INFORMATION_FILES_NAMES[locale].HomeguideWithoutSPPDF}
            </a>
          </li>
        )}
      </ul>
    </div>
  )
}

SpecItems.propTypes = {
  downloadLink: PropTypes.shape({
    DWGPlanView: PropTypes.string,
    dwgFrontView: PropTypes.string,
    DWGSideView: PropTypes.string,
    DXFPlanView: PropTypes.string,
    DXFFrontView: PropTypes.string,
    DXFSideView: PropTypes.string,
    ThreeDDXF: PropTypes.string,
    product3D3DS: PropTypes.string,
    product3DSketchup: PropTypes.string,
    ThreeDRevit: PropTypes.string,
    InstallationWithoutSPPDF: PropTypes.string,
    SpecPDFFileName: PropTypes.string,
    HomeguideWithSPPDF: PropTypes.string,
    HomeguideWithoutSPPDF: PropTypes.string,
  }),
  linkType: PropTypes.string,
  locale: PropTypes.string,
}

export default SpecItems
